import _ from 'lodash';
import {
    FETCH_EDUCATIONS,
    FETCH_EDUCATION,
    DELETE_EDUCATION,
    EDIT_EDUCATION,
    NEW_EDUCATION
} from '../actions/types';


export const educationReducer = (state = {}, action) => {
    switch (action.type) {
        case FETCH_EDUCATIONS :
            return {..._.mapKeys(action.payload, '_id')}
        case NEW_EDUCATION : 
            return {...state, [action.payload.id]: action.payload};
        case EDIT_EDUCATION : 
            return {...state, [action.payload.id]: action.payload};
        case DELETE_EDUCATION : 
            return _.omit(state, action.payload);        
        default : 
            return state;
    }
};


export const selectedEducationReducer = (selectedEducation = {}, action) => {
    if (action.type === FETCH_EDUCATION) {
        return action.payload;
    }

    return selectedEducation;
};

